<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <v-sheet class="w-full">
        <i-card-vertical
          headerTitle="안전보건경영 관리"
          device="multi"
          contentsClass="overflow-x-hidden overflow-y-auto pr-5"
        >
          <template v-slot:body>
            <v-tabs active-class="active_tab" class="mt-3" v-model="tab">
              <v-tab
                class="px-2"
                v-for="item in tabs"
                :key="item.tabpageId"
                @click="clickTab(item.tabpageId)"
              >{{ item.title }}</v-tab>
              <v-tabs-items v-model="tab" :touchless="true">
                <!-- ######################## 기존 ############################ -->
                <v-tab-item>
                  <NewPolicy ref="newPolicy" :datasource="newShData" />
                </v-tab-item>
                <!-- ######################## 신규 ############################ -->
                <v-tab-item>
                  <LegacyPolicy ref="legacyPolicy" :datasource="legacyShData" />
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>

            <!-- <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
                    <i-card-top
                      class="d-md-flex"
                      headerTitle
                      :useBtnList="['btnSearch']"
                      @btnSearch="getUserComment()"
                    >
                      <template v-slot:body>
                        <v-layout>
                          <v-row no-gutters class="center pa-0 pa-md-2 pb-0">
                            <v-col cols="4" md="4">
                              <v-select
                                :menu-props="{ offsetY: true }"
                                color="primary"
                                class="mx-1"
                                item-text="sub1"
                                item-value="grpAuthCd"
                                :items="selectedGrp"
                                placeholder="그룹권한"
                                dense
                                outlined
                                clearable
                                v-model="selectedGrpCd"
                              />
                            </v-col>
                          </v-row>
                        </v-layout>
                      </template>
                    </i-card-top>
            </v-col>-->
          </template>

          <template v-slot:drawer>
            <v-navigation-drawer
              v-model="feedbackShow"
              width="75%"
              absolute
              right
              temporary
              class="feedback-area"
            >
              <expansionPanelList
                :subTitle="'근로자 의견'"
                :datasource="userCommentList"
                headerDefaultColor="#fff"
                headerExpandedColor="#fff"
              />
            </v-navigation-drawer>

            <v-navigation-drawer
              v-model="procedureShow"
              width="75%"
              absolute
              right
              temporary
              class="feedback-area"
            >
              <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
            </v-navigation-drawer>
          </template>
        </i-card-vertical>
      </v-sheet>
      <v-sheet class="iCardRightWrap" :key="selectedTab">
        <i-card-right
          v-if="selectedTab === 'new'"
          :useBtnList="buttonUseListNew"
          @btnSample="btnSample"
          @btnSearch="btnSearch()"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        ></i-card-right>
        <i-card-right
          v-else-if="selectedTab === 'legacy'"
          :useBtnList="buttonUseListLagacy"
          @btnSearch="btnSearch()"
          @btnImageDownload="btnImageDownload()"
          @btnImageLoad="btnImageLoad()"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        ></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'근로자 의견'"
              :icon="'feedback'"
              @click="feedbackShow = !feedbackShow"
              :appendDivider="true"
            ></i-icon-button>
            <!-- <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>-->
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import expansionPanelList from '@/components/esgCommon/expansionPanelList.vue'
import notify from 'devextreme/ui/notify'
import { getCurrentDate } from '@/utils/common.js'
// 사용자 컴포넌트
import LegacyPolicy from './LegacyPolicy' // '기존'탭 컴포넌트
import NewPolicy from './NewPolicy' // '신규'탭 컴포넌트
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'

// API
import { getSHManageData, getSHManagePolicyComment, getSHManageDataReport } from '@/api/leaderShip/shManagePolicy'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
import { getLeaderShipProcedure } from '@/api/procedure/leaderShipProcedure.js'

export default {
  mixins: [baseview],
  components: {
    // 'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    expansionPanelList,
    LegacyPolicy,
    NewPolicy,
    ProcedureComponent
  },
  data() {
    return {
      initCompId: '',
      buttonUseListNew: [
        'btnSample', // 예시보기
        'btnSearch', // 조회
        'btnSave', // 저장
        'btnPrint' // 출력
      ],
      buttonUseListLagacy: [
        'btnSearch', // 조회
        'btnImageDownload', // 이미지 다운로드
        'btnImageLoad', // 이미지 불러오기
        'btnSave', // 저장
        'btnPrint' // 출력
      ],
      tabs: [
        { tabpageId: 'new', title: '신규' },
        { tabpageId: 'legacy', title: '기존' }
      ],
      tab: '', // 기존, 신규 탭 구분변수
      selectedTab: 'new', // 기존, 신규 탭 구분변수
      legacyShData: {}, // 기존 데이터
      newShData: {}, // 신규 데이터
      userCommentList: [],

      defaultComment: [
        {
          main: '의견 없음',
          sub1: '-',
          sub2: getCurrentDate().replaceAll('-', '.'),
          text: '근로자 의견 없음'
        }
      ],
      selectedGrp: [
        {
          sub1: '전체',
          grpAuthCd: 'all'
        }
      ],
      selectedGrpCd: 'all',
      feedbackShow: false, // 피드백 보이기
      procedureShow: false // 절차서 보이기
    }
  },
  watch: {},
  computed: {},
  created() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  activated() {
    // if (this.changedCompFlag(this.initCompId)) {
    //   // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
    //   // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
    //   this.initCompId = this.getCompId()
    //   this.btnSearch(true)
    // }
  },
  methods: {
    btnSample() {
      this.$refs.newPolicy.btnSampleLoad() // newPoily 신규 탭 예시보기
    },
    btnImageDownload() {
      this.$refs.legacyPolicy.btnImageDownload() // legacyPolicy 기존 탭 이미지 다운로드
    },
    btnImageLoad() {
      this.$refs.legacyPolicy.btnImageLoad() // legacyPolicy 기존 탭 이미지 불러오기
    },
    async btnSearch(init = false) {
      // 조회
      let param = {
        clntId: this.getClntId()
      }
      this.openLoading()
      if (this.selectedTab == 'legacy' || init) {
        await getSHManageData({ ...param, ...{ dataType: '00001' } }, true).then(res => {
          this.legacyShData = res.clntId ? res : {}
        })
      }
      if (this.selectedTab == 'new' || init) {
        await getSHManageData({ ...param, ...{ dataType: '00002' } }, true).then(res => {
          this.newShData = res.clntId ? res : {}
        })
      }
      this.getUserComment()

      this.endLoading()
    },
    async btnSave() {
      // this.$refs.newPolicy.btnSave().then(res => {})
      if (this.selectedTab === 'new') await this.$refs.newPolicy.btnSave() // newPoily 신규 탭 저장
      if (this.selectedTab === 'legacy') await this.$refs.legacyPolicy.btnSave() // legacyPolicy 기존 탭 저장
    },
    btnPrint(type) {
      // 출력
      if (Object.keys(this.newShData).length > 0 || !this.$refs.newPolicy.params.__created__) {
        // 신규 데이터가 있을 경우
        this.openLoading()
        let params = {
          clntId: this.getClntId(),
          type: type
        }
        getSHManageDataReport(params, false)
          .then(res => {
            this.downloadReport(res)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
        return
      } else if (Object.keys(this.legacyShData).length > 0 || !this.$refs.legacyPolicy.params.__created__) {
        // 신규데이터가 없고 기존 데이터만 있을 경우
        this.vSnackbar(this.$t('신규 데이터가 없습니다. 기존 이미지 다운로드 버튼을 클릭해주세요.'), 'warn')
        return
      }
      this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
    },

    getUserComment() {
      this.selectedGrp = [
        {
          sub1: '전체',
          grpAuthCd: 'all'
        }
      ]
      let params = {
        clntId: this.getClntId(),
        grpAuthCd: this.selectedGrpCd
        // writeDt: ''
      }

      if (!this.legacyShData.clntId || !this.newShData.clntId) {
        this.userCommentList = this.defaultComment
      } else {
        getSHManagePolicyComment(params, true).then(res => {
          if (res.success) {
            if (res.list.length == 0) {
              this.userCommentList = this.defaultComment
              return
            }
            res.list.forEach(el => {
              el.sub1 = el.grpAuthNm
              el.sub2 = el.updatedBy ? el.updatedAt.slice(0, 10).replaceAll('-', '.') : el.createdAt.slice(0, 10).replaceAll('-', '.')
              el.text = el.workerComment
              el.main = el.korNm
            })
            this.userCommentList = res.list
            console.log('this.userCommentList', this.userCommentList)
            this.selectedGrp = this.selectedGrp.concat(this.userCommentList)
          }
        })
      }
      // if (this.selectedTab == 'legacy' && this.legacyShData.clntId) {
      //   // params.writeDt = this.legacyShData.writeDt
      //   // params.dataType = '00001'
      //   getSHManagePolicyComment(params).then(res => {
      //     if (res.list.length == 0) {
      //       this.userCommentList = this.defaultComment
      //       return
      //     }
      //     res.list.forEach(el => {
      //       el.sub2 = el.sub2.slice(0, 10).replaceAll('-', '.')
      //     })
      //     this.userCommentList = res.list
      //   })
      // } else if (this.selectedTab == 'new' && this.newShData.clntId) {
      //   // params.writeDt = this.newShData.writeDt
      //   // params.dataType = '00002'
      //   getSHManagePolicyComment(params).then(res => {
      //     if (res.list.length == 0) {
      //       this.userCommentList = this.defaultComment
      //       return
      //     }
      //     res.list.forEach(el => {
      //       el.sub2 = el.sub2.slice(0, 10).replaceAll('-', '.')
      //     })
      //     this.userCommentList = res.list
      //   })
      // }
    },

    async clickTab(id) {
      if (this.selectedTab === id) return
      this.selectedTab = id
      this.getUserComment()
    }
  }
}
</script>

<style lang="scss"></style>
